import {Box, Button, CircularProgress, TextField, Typography} from "@mui/material";
import React, {useCallback, useEffect, useState} from "react";
import _ from "lodash";
import { signInWithEmailAndPassword, getAuth } from "firebase/auth"

const styles = {
    root: {
        display: 'flex',
        width: '100vw',
        height: '100vh',
        justifyContent: 'center',
        alignItems: 'center',
    },
    loginBox: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: "16px",
    },
    title: {
        fontSize: "24px",
    },
    errorMessage: {
        color: 'red',
        fontSize: '14px',
        height: '24px',
    },
    inputBox: {
        display: 'flex',
        flexDirection: 'column',
        gap: '32px',
        width: '400px',
        margin: '16px 0',
    },
    inputField: {

    },
    loginButton: {
        width: '200px',
        height: '48px',
        background: '#64a764'
    },
    loadingRoot: {
        position: "absolute",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        zIndex: 1,
        background: "#EEEEEE73",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    },
    loadingBox: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
    },
}

const LoginView = (props) => {

    const [email, setEmail] = useState()
    const [password, setPassword] = useState()
    const [isErrorMessage, setIsErrorMessage] = useState()
    const [loading, setLoading] = useState(false)

    const onLogin = useCallback(() => {
        if (!email || !password) { return }
        setLoading(true)
        signInWithEmailAndPassword(getAuth(), email, password)
            .catch(e => {
                console.log(e)
                setIsErrorMessage("IDかパスワードが間違っています")
            })
            .finally(() => setLoading(false))
    }, [email, password])

    useEffect(() => {
        setIsErrorMessage(null)
    }, [email, password])

    return (
        <Box style={styles.root}>
            <Box style={styles.loginBox}>
                <Typography style={styles.title}>横浜市街路樹調査</Typography>
                <Typography style={styles.errorMessage}>
                    {isErrorMessage ?? " "}
                </Typography>
                <Box style={styles.inputBox}>
                    <TextField
                        style={styles.inputField}
                        label="ID"
                        value={email}
                        onChange={e => setEmail(e.target.value)}
                        type="email"/>
                    <TextField
                        style={styles.inputField}
                        label="パスワード"
                        value={password}
                        onChange={e => setPassword(e.target.value)}
                        type="password"/>
                </Box>
                <Button
                    variant="contained"
                    disabled={_.isEmpty(email) || _.isEmpty(password)}
                    style={styles.loginButton}
                    onClick={onLogin}
                >ログイン</Button>
            </Box>
            {loading && (<Box style={styles.loadingRoot}>
                <Box style={styles.loadingBox}>
                    <CircularProgress />
                    <Typography>ログイン中...</Typography>
                </Box>
            </Box>)}
        </Box>
    )

}

export default LoginView
